import { render, staticRenderFns } from "./RuleAlarmTag.vue?vue&type=template&id=1e98eb10&scoped=true"
import script from "./RuleAlarmTag.vue?vue&type=script&lang=ts"
export * from "./RuleAlarmTag.vue?vue&type=script&lang=ts"
import style0 from "./RuleAlarmTag.vue?vue&type=style&index=0&id=1e98eb10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e98eb10",
  null
  
)

export default component.exports